const ACCESS_MGMT_FILTER_SERIES = new Set([
  'access_session',
  'keypad_state',
  'access_code_refused',
]);

/**
 * Identify access management data points so they can be filtered out on some pages
 * @param dataPointId
 * @returns {boolean}
 */

export function isAccessDataPoint(dataPointId) {
  return ACCESS_MGMT_FILTER_SERIES.has(dataPointId);
}
